import React from 'react';

export default function ProgressMatrix({ companies, candidates, stations, expandedCompanies, onToggleCompany }) {
  return (
    <section className="section" style={{ margin: '24px 16px' }}>
      <h2>📊 Grid Progress Matrix</h2>
      <div style={{ fontSize: '0.75em', color: '#666', margin: '4px 0 10px' }}>
        Legend:{' '}
        <span style={{ color: 'white', background: '#28a745', padding: '0 4px', borderRadius: 2 }}>P</span> Passed |{' '}
        <span style={{ color: 'white', background: '#dc3545', padding: '0 4px', borderRadius: 2 }}>F</span> Failed |{' '}
        <span style={{ color: '#212529', background: '#ffc107', padding: '0 4px', borderRadius: 2 }}>F</span> Partial Fail |{' '}
        <span style={{ color: '#ccc' }}>—</span> Incomplete
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="dashboard-table progress-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
          <thead>
            <tr style={{ background: '#f8f9fa' }}>
              <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6', width: 40 }}></th>
              <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6', minWidth: 200 }}>Company / Candidate</th>
              <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Program Name</th>
              {stations.map(st => (
                <th key={st.id} style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6', minWidth: 60 }} title={st.name}>
                  St {st.station_number}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {companies.map((company) => {
              const isExpanded = expandedCompanies.has(company.id);
              return (
                <React.Fragment key={company.id}>
                  <tr
                    style={{ borderBottom: '1px solid #dee2e6', background: isExpanded ? '#f1f5f9' : 'transparent', cursor: 'pointer' }}
                    onClick={() => onToggleCompany(company.id)}
                  >
                    <td style={{ padding: '8px 10px', textAlign: 'center', color: '#666', fontSize: '0.8em' }}>
                      {isExpanded ? '▼' : '▶'}
                    </td>
                    <td style={{ padding: '8px 10px', fontWeight: 'bold' }}>{company.name}</td>
                    <td style={{ padding: '8px 10px' }}>{company.program_name || '—'}</td>
                    {stations.map(st => {
                      const result = company.station_results?.[st.id];
                      return (
                        <td key={st.id} style={{ padding: '8px 10px', textAlign: 'center' }}>
                          {result === 'pass' && <span style={{ color: 'white', background: '#28a745', padding: '2px 6px', borderRadius: 4, fontWeight: 'bold' }}>P</span>}
                          {result === 'fail' && <span style={{ color: 'white', background: '#dc3545', padding: '2px 6px', borderRadius: 4, fontWeight: 'bold' }}>F</span>}
                          {result === 'mixed_fail' && <span style={{ color: '#212529', background: '#ffc107', padding: '2px 6px', borderRadius: 4, fontWeight: 'bold' }}>F</span>}
                          {(!result || result === 'blank') && <span style={{ color: '#ccc' }}>—</span>}
                        </td>
                      );
                    })}
                  </tr>
                  {isExpanded &&
                    candidates
                      .filter(c => c.company_id === company.id)
                      .map(candidate => (
                        <tr key={candidate.id} style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                          <td style={{ padding: '6px 10px' }}></td>
                          <td style={{ padding: '6px 10px', paddingLeft: '24px' }}>
                            <span style={{ color: '#999', marginRight: 8 }}>↳</span>
                            {candidate.first_name} {candidate.last_name}
                            <span style={{ color: '#aaa', fontSize: '0.85em', marginLeft: 6 }}>(ID: {candidate.candidate_id})</span>
                          </td>
                          <td style={{ padding: '6px 10px' }}></td>
                          {stations.map(st => {
                            const result = candidate.station_results?.[st.id];
                            return (
                              <td key={st.id} style={{ padding: '6px 10px', textAlign: 'center' }}>
                                {result === 'pass' && <span style={{ color: 'white', background: '#28a745', padding: '2px 6px', borderRadius: 4, fontSize: '0.85em' }}>P</span>}
                                {result === 'fail' && <span style={{ color: 'white', background: '#dc3545', padding: '2px 6px', borderRadius: 4, fontSize: '0.85em' }}>F</span>}
                                {result === 'mixed_fail' && <span style={{ color: '#212529', background: '#ffc107', padding: '2px 6px', borderRadius: 4, fontSize: '0.85em' }}>F</span>}
                                {(!result || result === 'blank') && <span style={{ color: '#e2e8f0' }}>—</span>}
                              </td>
                            );
                          })}
                        </tr>
                      ))
                  }
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
